import type { ReactNode } from "react";

import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { useMetricWidgetContext } from "../widget/donut-metric/MetricWidgetContext";
import type { IChartDataItem } from "../widget/donut-metric/types";

import { Column } from "./Column";

export interface ILegendColumnConfig {
    header: string;
    render: (item: IChartDataItem, allItems: IChartDataItem[]) => ReactNode;
    textAlign?: "left" | "right";
}

interface IMetricLegendProps {
    columns: ILegendColumnConfig[];
    dataAutomation: string;
}

export const MetricLegend = ({ columns, dataAutomation }: IMetricLegendProps) => {
    const {
        state: { compactData },
    } = useMetricWidgetContext();

    return (
        <Stack
            gap="12px"
            flex="1"
            data-automation={dataAutomation}
        >
            <Flex gap="8px">
                {columns.map((col) => (
                    <Column
                        key={col.header}
                        fontVariant="caption"
                        textAlign={col.textAlign}
                    >
                        {col.header}
                    </Column>
                ))}
            </Flex>
            <Stack gap="8px">
                {compactData.map((item) => (
                    <Flex
                        key={item.name}
                        gap="8px"
                        alignItems="center"
                    >
                        {columns.map((col) => col.render(item, compactData))}
                    </Flex>
                ))}
            </Stack>
        </Stack>
    );
};

MetricLegend.Column = Column;
